import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, FileText, Trash2, Calendar } from 'lucide-react';
import config from '../config';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [presentations, setPresentations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPresentations();
  }, []);

  const loadPresentations = async () => {
    try {
      const response = await fetch(`${config.serverUrl}/api/presentations/list/default-user`);
      if (response.ok) {
        const data = await response.json();
        setPresentations(data.presentations || []);
      }
    } catch (error) {
      console.error('Error loading presentations:', error);
    } finally {
      setLoading(false);
    }
  };

  const createNewPresentation = () => {
    // CORREÇÃO: Usar caminho relativo correto
    navigate('editor/new');
  };

  const openPresentation = (id) => {
    // CORREÇÃO: Usar caminho relativo correto
    navigate(`editor/${id}`);
  };

  const deletePresentation = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Tem certeza que deseja excluir esta apresentação?')) return;

    try {
      const response = await fetch(`${config.serverUrl}/api/presentations/${id}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setPresentations(presentations.filter(p => p._id !== id));
      }
    } catch (error) {
      console.error('Error deleting presentation:', error);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="home-container">
        <div className="loading">Carregando...</div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="home-header">
        <h1>Link2.do Presentation</h1>

        <button onClick={createNewPresentation} className="btn btn-primary">
          <Plus size={20} />
          Nova Apresentação
        </button>
      </div>

      <div className="home-content">
        {presentations.length === 0 ? (
          <div className="empty-state">
            <FileText size={64} />
            <h2>Nenhuma apresentação criada</h2>
            <p>Clique no botão abaixo para criar sua primeira apresentação</p>
            <button onClick={createNewPresentation} className="btn btn-primary btn-large">
              <Plus size={24} />
              Criar Apresentação
            </button>
          </div>
        ) : (
          <div className="presentations-grid">
            {presentations.map((presentation) => (
              <div
                key={presentation._id}
                className="presentation-card"
                onClick={() => openPresentation(presentation._id)}
              >
                <div className="presentation-thumbnail">
                  {presentation.slides?.[0]?.thumbnail ? (
                    <img src={presentation.slides[0].thumbnail} alt="Thumbnail" />
                  ) : (
                    <div className="empty-thumbnail">
                      <FileText size={48} />
                    </div>
                  )}
                </div>
                <div className="presentation-info">
                  <h3>{presentation.name || 'Sem título'}</h3>
                  <div className="presentation-meta">
                    <span><Calendar size={14} /> {formatDate(presentation.updatedAt)}</span>
                    <span>{presentation.slides?.length || 0} slides</span>
                  </div>
                </div>
                <button
                  className="delete-btn"
                  onClick={(e) => deletePresentation(presentation._id, e)}
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;